var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"chip mb-2",style:('background-color: ' + _vm.color.hexacode),on:{"click":_vm.select}},'span',attrs,false),on),[(_vm.selected)?_c('v-icon',{class:_vm.getTextColor},[_vm._v("mdi-check")]):_vm._e()],1)]}}])},[_vm._v(" "+_vm._s(_vm.color.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }